import React from 'react'
import Breadcrumb from '../BreadCrumb/BreadCrumb'
import Footer from '../Container/Footer/Footer'
import HomeContact from '../Container/HomePageContainer/HomeContact'
import HomeContactOne from '../Container/HomePageContainer/HomeContactOne'
import SEO from '../Container/SEO/SEO'
import TopNav from '../Container/TopNav/TopNav'

export default function Contact() {
  return (
    <React.Fragment>
      <SEO title="Kalpataru || Contact Us" />
      <TopNav />
      <Breadcrumb image="/images/breadcrumb/contact.jpg" title="Home" content="Contact Us" />
      <HomeContact />
      <HomeContactOne />
      <Footer />
    </React.Fragment>
  )
}
